export default __webpack_public_path__ + "static/Default-5d1f0aab67e63b1fc82def38dcbb34aa.png";